module.exports = __webpack_public_path__ + "img/BRCA4_Neutrophils.0cd08bed.png";